(function () {
function init(root) {
var BYS = window.BYS;
if (!BYS || !BYS.Picker) return;
if (!root || root.getAttribute('data-bys-ready') === '1') return;
root.setAttribute('data-bys-ready', '1');
var money = BYS.money, esc = BYS.esc;
var CTA = root.getAttribute('data-cta') || 'Add set to cart';
var OPEN_CART = root.getAttribute('data-open-cart') === 'true';
var PRESELECT = root.getAttribute('data-preselect') === 'true';
BYS._gallery = root.getAttribute('data-gallery') === 'true';
var LADDER = (root.getAttribute('data-ladder') || '10,25,40,60')
.split(',').map(function (n) { return parseFloat(n) || 0; });
var cache = {};
function all(sel) { return [].slice.call(root.querySelectorAll(sel)); }
function fetchProduct(handle) {
if (cache[handle]) return Promise.resolve(cache[handle]);
return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
.then(function (r) { if (!r.ok) throw new Error('product fetch failed'); return r.json(); })
.then(function (p) { cache[handle] = p; return p; });
}
var ctx = { fetchProduct: fetchProduct, onChange: function () { onChange(); } };
var panels = all('[data-bys-panel]');
var tabs = all('[data-bys-tab]');
var groups = {};
panels.forEach(function (panel) {
var id = panel.getAttribute('data-bys-panel');
var top = new BYS.Picker(panel.querySelector('[data-bys-side="top"]'), ctx);
var bottom = new BYS.Picker(panel.querySelector('[data-bys-side="bottom"]'), ctx);
var hexes = {}, lows = {};
try { hexes = JSON.parse(panel.getAttribute('data-bys-swatches') || '{}'); } catch (e) {}
try { lows = JSON.parse(panel.getAttribute('data-bys-lowstock') || '{}'); } catch (e) {}
top.swatchHex = hexes; bottom.swatchHex = hexes;
top.lowstock = lows; bottom.lowstock = lows;
groups[id] = {
top: top, bottom: bottom,
topHandles: [].slice.call(top.styleSel.options).map(function (o) { return o.value; }).filter(Boolean),
bottomHandles: [].slice.call(bottom.styleSel.options).map(function (o) { return o.value; }).filter(Boolean)
};
});
var activeId = panels.length ? panels[0].getAttribute('data-bys-panel') : null;
function active() { return groups[activeId]; }
tabs.forEach(function (tab) {
tab.addEventListener('click', function () {
activeId = tab.getAttribute('data-bys-tab');
panels.forEach(function (p) { p.hidden = p.getAttribute('data-bys-panel') !== activeId; });
tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === tab)); });
if (PRESELECT) { var g = active(); g.top.preselect(); g.bottom.preselect(); }
onChange(); paintLadder();
});
});
var fulls = all('[data-bys-fullprice]');
var pays = all('[data-bys-payprice]');
var savenotes = all('[data-bys-savenote]');
var states = all('[data-bys-state]');
var shipEls = all('[data-bys-shipfree]');
var errorEls = all('[data-bys-error]');
var addedEls = all('[data-bys-added]');
var againEls = all('[data-bys-again]');
var addBtn = root.querySelector('[data-bys-add]');
var instEl = root.querySelector('[data-bys-installments]');
var addedTimer = null;
var pendingErr = null;
function setError(msg) { errorEls.forEach(function (el) { el.hidden = !msg; el.textContent = msg || ''; }); }
function showAdded(on) { addedEls.forEach(function (el) { el.classList.toggle('is-shown', !!on); }); }
var barEl = root.querySelector('[data-bys-sticky]');
var barWas = root.querySelector('[data-bys-sticky-was]');
var barPay = root.querySelector('[data-bys-sticky-price]');
var barSave = root.querySelector('[data-bys-sticky-save]');
var barHint = root.querySelector('[data-bys-sticky-hint]');
var barAdd = root.querySelector('[data-bys-sticky-add]');
var barHead = root.querySelector('[data-bys-sticky-min]');
var sheetEl = root.querySelector('[data-bys-sticky-body]');
function ladderFor(sets) { return sets <= 0 ? 0 : (LADDER[Math.min(sets, LADDER.length) - 1] || 0); }
var cartPooled = 0;
var cartState = { count: 0, total: 0 };
var lastTok = null;
var lastEff;
var lastAddedPair = null;
var userActed = false;
var allTops = {}, allBottoms = {};
Object.keys(groups).forEach(function (id) {
groups[id].topHandles.forEach(function (h) { allTops[h] = 1; });
groups[id].bottomHandles.forEach(function (h) { allBottoms[h] = 1; });
});
var cartSeq = 0;
function readCart() {
var seq = ++cartSeq;
return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (cart) {
if (seq !== cartSeq) return;
cartState.count = cart ? (cart.item_count || 0) : 0;
cartState.total = cart ? (cart.total_price || 0) : 0;
lastTok = cartState.count + ':' + cartState.total;
var tops = 0, bottoms = 0;
if (cart) {
(cart.items || []).forEach(function (it) {
if (allTops[it.handle]) tops += it.quantity;
if (allBottoms[it.handle]) bottoms += it.quantity;
});
}
var prev = cartPooled;
cartPooled = Math.min(tops, bottoms);
if (cartPooled < prev) lastAddedPair = null;
})
.catch(function () {});
}
function totalSaving() { return ladderFor(cartPooled); }
function have() { return cartPooled; }
function marginal() { return Math.round((ladderFor(have() + 1) - ladderFor(have())) * 100); }
function effState() {
var g = active();
var t = g && g.top.variant, b = g && g.bottom.variant;
var pair = (t && b) ? (t.id + ':' + b.id) : null;
var extra = (pair && pair !== lastAddedPair) ? 1 : 0;
return { t: t, b: b, pair: pair, extra: extra,
eff: Math.min(have() + extra, LADDER.length) };
}
function styleName(picker) {
var o = picker.styleSel.options[picker.styleSel.selectedIndex];
return o ? String(o.text).replace(/\s*★.*$/, '') : '';
}
function slotPaint(side, picker, otherPicked) {
if (BYS._api && BYS._api.slotPaint) BYS._api.slotPaint(side, picker, otherPicked);
}
function onChange() {
var g = active();
var es = effState();
var t = es.t, b = es.b;
if (t && b) setError(pendingErr || '');
slotPaint('top', g && g.top, !!b);
slotPaint('bottom', g && g.bottom, !!t);
var stateTxt;
if (t && b) {
if (es.extra) {
var d0 = marginal();
stateTxt = d0 > 0 ? 'You built it. Add it to lock in ' + money(d0) + ' off.' : 'You built it.';
} else {
var nxt = ladderFor(have() + 1);
stateTxt = nxt > ladderFor(have())
? 'Added. One more set unlocks ' + money(nxt * 100) + ' off.'
: 'Added. Maximum savings unlocked.';
}
} else if (t) { stateTxt = 'Now choose your bottom.'; }
else if (b) { stateTxt = 'Now choose your top.'; }
else { stateTxt = 'Pick your top.'; }
states.forEach(function (el) { el.textContent = stateTxt; });
if (t && b) {
var sum = t.price + b.price;
var was = (t.compare_at_price || t.price) + (b.compare_at_price || b.price);
if (was < sum) { was = sum; }
var delta = marginal();
var net = Math.max(sum - delta, 0);
var saved = was - net;
fulls.forEach(function (el) { el.hidden = saved <= 0; el.textContent = money(was); });
savenotes.forEach(function (el) { el.textContent = saved > 0 ? 'You save ' + money(saved) + (delta > 0 ? ' · ' + money(delta) + ' comes off at checkout' : '') : ''; });
pays.forEach(function (el) { el.textContent = money(net); });
if (barWas) { barWas.hidden = saved <= 0; barWas.textContent = money(was); }
if (barPay) barPay.textContent = money(net);
if (barSave) barSave.textContent = saved > 0 ? 'Saving ' + money(saved) : '';
addBtn.disabled = false; addBtn.textContent = CTA;
if (barAdd) { barAdd.disabled = false; barAdd.textContent = CTA; }
shipEls.forEach(function (el) { el.hidden = net < 12000; });
if (instEl) {
instEl.textContent = 'or 4 interest-free payments of ' + money(Math.round(net / 4)) + ' with Shop Pay';
instEl.hidden = false;
}
} else {
fulls.forEach(function (el) { el.hidden = true; });
savenotes.forEach(function (el) { el.textContent = ''; });
pays.forEach(function (el) { el.textContent = 'Build your set to see the price'; });
if (barWas) barWas.hidden = true;
if (barPay) barPay.textContent = 'Build your set';
if (barSave) barSave.textContent = '';
addBtn.disabled = true;
if (barAdd) barAdd.disabled = true;
shipEls.forEach(function (el) { el.hidden = true; });
if (instEl) instEl.hidden = true;
}
paintBarHint(t, b);
paintLadder();
try { paintInfo(); } catch (e) { if (window.console) console.error('BYS', e); }
}
function paintBarHint(t, b) {
if (BYS._api && BYS._api.paintHint) {
BYS._api.paintHint(!!(t && b), effState().extra, marginal(), have(), LADDER.length, ladderFor(have() + 1) * 100);
}
}
function paintLadder() {
var eff = have();
var wasEff = lastEff;
all('[data-bys-ladder-steps]').forEach(function (steps) {
[].slice.call(steps.children).forEach(function (el, i) {
el.classList.toggle('is-won', i < eff);
el.classList.toggle('is-next', i === eff);
el.classList.toggle('is-far', i > eff);
if (wasEff !== undefined && eff > wasEff && i === eff - 1 && userActed) {
el.classList.add('just-hit');
setTimeout(function () { el.classList.remove('just-hit'); }, 400);
}
});
});
all('[data-bys-prog]').forEach(function (p) {
p.style.width = (eff / LADDER.length * 100) + '%';
});
lastEff = eff;
all('[data-bys-ladder-msg]').forEach(function (msg) {
if (eff <= 0) {
msg.textContent = 'Build your first set to save ' + money(LADDER[0] * 100) + '.';
} else if (eff >= LADDER.length) {
msg.textContent = 'Maximum savings unlocked. ' + money(ladderFor(eff) * 100) + ' comes off at checkout.';
} else {
msg.innerHTML = 'One more set unlocks <b>' + money(ladderFor(eff + 1) * 100) + ' off</b>.';
}
});
all('[data-bys-milestone]').forEach(function (m) {
if (!cartState.count) { m.hidden = true; return; }
if (cartState.total >= 12000) {
m.innerHTML = '&#10003; Free Continental U.S. shipping unlocked';
} else {
m.textContent = 'Free Continental U.S. shipping at $120';
}
m.hidden = false;
});
if (BYS._api && BYS._api.cartLine) BYS._api.cartLine();
}
var infoWrap = root.querySelector('[data-bys-infowrap]');
var garmEl = root.querySelector('[data-bys-garm]');
var prevHandles = { top: null, bottom: null };
function paintInfo() {
var g = active(), picked = [];
if (g && g.top.product) picked.push({ handle: g.top.product.handle, label: styleName(g.top), side: 'top' });
if (g && g.bottom.product) picked.push({ handle: g.bottom.product.handle, label: styleName(g.bottom), side: 'bottom' });
var th = g && g.top.product ? g.top.product.handle : null;
var bh = g && g.bottom.product ? g.bottom.product.handle : null;
if (th !== prevHandles.top || bh !== prevHandles.bottom) {
var side = BYS._lastSide === 'bottom' ? 'bottom' : 'top';
BYS._infoSide = 0;
for (var i = 0; i < picked.length; i++) { if (picked[i].side === side) BYS._infoSide = i; }
prevHandles.top = th; prevHandles.bottom = bh;
}
BYS.renderInfo(root, infoWrap, picked, garmEl, BYS._infoSide || 0, function () {
BYS.renderInfo(root, infoWrap, picked, garmEl, BYS._infoSide || 0, null);
});
}
function refreshCart() {
if (BYS._api && BYS._api.refreshCart) BYS._api.refreshCart(OPEN_CART);
}
function doAdd() {
var g = active();
var t = g.top.variant, b = g.bottom.variant;
if (!t || !b) return;
userActed = true;
var setId = 'set-' + Date.now();
pendingErr = null;
setError('');
showAdded(false);
addBtn.disabled = true; addBtn.textContent = 'Adding...';
if (barAdd) { barAdd.disabled = true; barAdd.textContent = 'Adding...'; }
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({
items: [
{ id: t.id, quantity: 1, properties: { '_set_id': setId } },
{ id: b.id, quantity: 1, properties: { '_set_id': setId } }
]
})
})
.then(function (r) {
if (!r.ok) { return r.json().then(function (e) { throw e; }); }
return r.json();
})
.then(function () {
addBtn.disabled = false; addBtn.textContent = CTA;
if (barAdd) { barAdd.disabled = false; barAdd.textContent = CTA; }
lastAddedPair = t.id + ':' + b.id;
showAdded(true);
clearTimeout(addedTimer);
addedTimer = setTimeout(function () { showAdded(false); }, 7000);
BYS.trackAdd(t, b, g.top.product && g.top.product.title, g.bottom.product && g.bottom.product.title);
var seen = false;
try { seen = sessionStorage.getItem('bysConfetti') === '1'; } catch (e) {}
if (!seen) {
try { sessionStorage.setItem('bysConfetti', '1'); } catch (e) {}
var host = root.querySelector('.bys__rail');
if (!host || getComputedStyle(host).display === 'none') host = barEl;
BYS.confetti(host, 32);
}
refreshCart();
return readCart();
})
.then(function () {
paintLadder(); onChange();
var h = have();
againEls.forEach(function (el) {
if (h > 0 && h < LADDER.length) {
el.textContent = 'One more set unlocks ' + money(ladderFor(h + 1) * 100) + ' off';
el.hidden = false;
} else {
el.hidden = true;
}
});
})
.catch(function (e) {
addBtn.disabled = false; addBtn.textContent = CTA;
if (barAdd) { barAdd.disabled = false; barAdd.textContent = CTA; }
var emsg = (e && (e.description || e.message)) || '';
if (/maximum quantity|can.t add more|already in your cart|are in your cart/i.test(emsg)) {
emsg = 'That is everything we have of this piece, and it is already in your cart.';
}
pendingErr = emsg ||
'Sorry, we could not add your set. Please try again.';
setError(pendingErr);
delete cache[g.top.styleSel.value];
delete cache[g.bottom.styleSel.value];
g.top.onStyle(true); g.bottom.onStyle(true);
});
}
addBtn.addEventListener('click', doAdd);
if (barAdd) barAdd.addEventListener('click', function () { if (!barAdd.disabled) doAdd(); });
if (barEl) barEl.hidden = false;
BYS._api = { root: root, groups: groups, active: active, setError: setError,
bar: barEl, barHead: barHead, sheet: sheetEl, agains: againEls,
marginal: marginal, styleName: styleName, repaint: onChange,
cartData: function () { return { count: cartState.count, total: cartState.total, saving: totalSaving() }; } };
root.addEventListener('click', function () { userActed = true; pendingErr = null; }, true);
if (PRESELECT && active()) { active().top.preselect(); active().bottom.preselect(); }
onChange();
function syncCart() {
var prev = lastTok;
return readCart().then(function () {
if (lastTok !== prev) {
paintLadder();
onChange();
}
});
}
syncCart();
setInterval(function () { if (!document.hidden) syncCart(); }, 3000);
window.addEventListener('pageshow', function () { syncCart(); });
window.addEventListener('focus', function () { syncCart(); });
document.addEventListener('cart:updated', function () { syncCart(); });
}
function boot(scope) {
var host = scope || document;
if (host.hasAttribute && host.hasAttribute('data-bys-root')) { init(host); return; }
var nodes = host.querySelectorAll('[data-bys-root]');
for (var i = 0; i < nodes.length; i++) init(nodes[i]);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { boot(document); });
} else {
boot(document);
}
document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
